import { render, staticRenderFns } from "./saveNewTemplate.vue?vue&type=template&id=7f3ba628&scoped=true&"
import script from "./saveNewTemplate.vue?vue&type=script&lang=js&"
export * from "./saveNewTemplate.vue?vue&type=script&lang=js&"
import style0 from "./saveNewTemplate.vue?vue&type=style&index=0&id=7f3ba628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3ba628",
  null
  
)

export default component.exports